import { globals } from '@/src/globals'

export const electroReferenceCategoryListFilter = (): void => {
  const allElectroReferenceBlocks = document.querySelectorAll('.js-electroReferencesList') as unknown as HTMLElement[]

  allElectroReferenceBlocks.forEach((referenceBlock: HTMLElement) => {
    const allFilterTrigers = referenceBlock.querySelectorAll('.js-electroReferenceCategoryList-soloCategoryFilter') as unknown as HTMLElement[]

    allFilterTrigers.forEach((triggerElement: HTMLElement) => {
      triggerElement.addEventListener('click', (e: Event): void => {
        const allElectroReferences = referenceBlock.querySelectorAll('.js-electroReferenceCategoryList-soloCategoryFilterTarget') as unknown as HTMLElement[]

        const filterValue = triggerElement.dataset.filterTarget as unknown as string

        allElectroReferences.forEach((electroReference: HTMLElement) => {
          // @ts-ignore
          const categoryID = electroReference.dataset.singleElectroreferenceCategory

          if (categoryID === filterValue) {
            electroReference.style.display = 'block'
          }
          else {
            electroReference.style.display = 'none'
          }
        })

        allFilterTrigers.forEach((categoryElement: HTMLElement) => {
          categoryElement.classList.remove('-active')
        })
        triggerElement.classList.add('-active')

        // Trigger resize to recalculate "Show more" buttons on electro-references
        window.dispatchEvent(new Event('resize'))

        // Recalculate all masonrys on the page due to the display change
        globals.masonryList.forEach((masonry: any) => {
          masonry.layout()
        })
      })
    })
  })
}
